import { PreviewItem, TransformationType } from "@apiserver-rest/ponder-data-client-base";

export function canFlip(item: PreviewItem): boolean {
    return (item.transformation && (item.transformation == TransformationType.Flip)) ? true : false;
}